import React from 'react';
import StepWizard from './StepWizard';
import './dropship.scss'
import { Iprops } from './dropshipinterface';
import { useTranslation } from 'react-i18next';
import { RESOURCE } from '../../const/resource';
import { ICartContextType } from '../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../ShoppingCart/shoppingcart';

const Dropship = (props: Iprops) => {

    const { t } = useTranslation();
    const { isHideItemSummary }: ICartContextType = useCartContext();

    return (
        <div className={`fulfilment_Wrapper ${isHideItemSummary ? 'fulfilment_fullwidth' : null}`}>
            <div className='row mb-4'>
                <div className='col-12'>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <span className='backtocart' title={t(RESOURCE.MyK_Label_ShoppingCart_Back_To_Cart)} onClick={props.shoppingcartOnClick} onKeyDown={() => { }} >{t(RESOURCE.MyK_Label_ShoppingCart_Back_To_Cart)}</span>
                </div>
            </div>
            <StepWizard isPromoChanges={props.isPromoChanges} isNextClick={props?.isNextClick} getItemSummaryDetailsWithoutLoading={props?.getItemSummaryDetailsWithoutLoading} shoppingcartOnClick={props.shoppingcartOnClick} phoneCodeOption={props?.phoneCodeOption} updateStepperDetails={props?.updateStepperDetails} itemSummaryDetails={props.itemSummaryDetails} getAvailablePartsDetails={props?.getAvailablePartsDetails} getIsNextDisableStatus={props?.getIsNextDisableStatus} availabilityDetails={props?.availabilityDetails} getAvailabilityDetails={props?.getAvailabilityDetails} fulfillmentDetailRes={props?.fulfillmentDetailRes} cartsDetails={props?.cartsDetails} setActive={props.setActive} formWizardRef={props.formWizardRef} saveFulfillmentType={props.saveFulfillmentType} />
        </div>
    )
}

export default Dropship